export type MovementTone = 'up' | 'down' | 'none';

export interface Movement {
  label: string;
  tone: MovementTone;
}

/** How a chart row moved since last week: "▲ 2", "▼ 1", or an em dash for a
 * track that held its place or is new to the chart. */
export function formatMovement(movement: number | null): Movement {
  if (movement === null || movement === 0) return { label: '—', tone: 'none' };
  if (movement > 0) return { label: `▲ ${movement}`, tone: 'up' };
  return { label: `▼ ${-movement}`, tone: 'down' };
}

/** Queue counts read as numbers, grouped: 1,482. */
export function formatQueueCount(count: number): string {
  return count.toLocaleString('en-GB');
}
